import { createSlice } from "@reduxjs/toolkit";
import * as vehicleActions from "./vehicleActions";

const InitialState = {
    isLoading: false,
    vehicle_recommendation: [],
    vehicles: [],
    hasError: false,
};

const vehicleReducer = createSlice({
    name: "vehicle_recommendation",
    initialState: InitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(vehicleActions.getVehicleRecommendation.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(vehicleActions.getVehicleRecommendation.fulfilled, (state, action) => {
                state.vehicle_recommendation = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(vehicleActions.getVehicleRecommendation.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
            .addCase(vehicleActions.getVehicles.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(vehicleActions.getVehicles.fulfilled, (state, action) => {
                state.vehicles = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(vehicleActions.getVehicles.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
    },
});

export default vehicleReducer.reducer;